//baseUrl
export const ApiBaseUrl = "https://api.kiorhealthcare.com/v1/user/";
export const SiteUrl = "https://www.kiorhealthcare.com";

//API Name
export const homeApi = "home";
export const getAllTestsApi = "getAllTests";
export const getPackageDetailsApi = "getPackageDetails";
